(() => {
  if (window.__mediaGalleryWishlistToggle) {
    window.__mediaGalleryWishlistToggle.initAll();
    return;
  }

  const withSwym = (cb) => {
    if (window._swat) { cb(window._swat); return; }
    (window.SwymCallbacks = window.SwymCallbacks || []).push(cb);
  };

  const updateState = (button, isWishlisted) => {
    if (button.getAttribute('aria-pressed') === String(isWishlisted)) return;
    const emptyIcon = button.querySelector('[data-wishlist-empty-icon]');
    const filledIcon = button.querySelector('[data-wishlist-filled-icon]');
    button.setAttribute('aria-pressed', String(isWishlisted));
    emptyIcon?.classList.toggle('hidden', isWishlisted);
    filledIcon?.classList.toggle('hidden', !isWishlisted);
  };

  const getSelectedColor = () => {
    const picker = document.querySelector('variant-picker');
    if (!picker) return '';
    const colorFieldset = picker.querySelector('fieldset[data-option-name-handle="color"]');
    if (colorFieldset) {
      const checked = colorFieldset.querySelector('input[type="radio"]:checked');
      if (checked && checked.value) return checked.value;
    }
    const colorSelect = picker.querySelector('select.variant-option__select[data-option-name-handle="color"]');
    if (colorSelect && colorSelect.value) return colorSelect.value;
    return '';
  };

  const buildProductUrlWithColor = (baseUrl, color) => {
    if (!baseUrl) return '';
    try {
      const url = new URL(baseUrl, window.location.origin);
      Array.from(url.searchParams.keys()).forEach((key) => url.searchParams.delete(key));
      if (color) url.searchParams.set('color', color);
      return url.toString();
    } catch (_e) {
      return baseUrl;
    }
  };

  const PENDING_SAVED_TTL_MS = 15 * 60 * 1000;

  const readPendingSavedItems = () => {
    try {
      const items = JSON.parse(window.localStorage.getItem('bonobos:pending-saved-items') || '[]');
      if (!Array.isArray(items)) return [];
      const cutoff = Date.now() - PENDING_SAVED_TTL_MS;
      return items.filter((item) => Number(item?.savedAt) > cutoff);
    } catch (_e) {
      return [];
    }
  };

  const pendingItemMatches = (item, payload) => {
    return Boolean(payload?.epi) && Number(item?.epi) === Number(payload.epi);
  };

  const hasPendingSavedItem = (payload) => {
    return readPendingSavedItems().some((item) => pendingItemMatches(item, payload));
  };

  const writePendingSavedItems = (items) => {
    try {
      window.localStorage.setItem('bonobos:pending-saved-items', JSON.stringify(items));
    } catch (_e) {
      // Swym remains the source of truth when storage is unavailable.
    }
  };

  const rememberPendingSavedItem = (payload) => {
    const items = readPendingSavedItems().filter((item) => !pendingItemMatches(item, payload));
    items.unshift({ ...payload, savedAt: Date.now() });
    writePendingSavedItems(items.slice(0, 50));
  };

  const forgetPendingSavedItem = (payload) => {
    writePendingSavedItems(readPendingSavedItems().filter((item) => !pendingItemMatches(item, payload)));
  };

  const buildPayload = (button) => {
    const empi = parseInt(button.dataset.wishlistEmpi, 10);
    const epi = parseInt(button.dataset.wishlistEpi, 10);
    if (!empi || !epi) return null;
    const color = getSelectedColor();
    const baseDu = button.dataset.wishlistDu || '';
    return {
      empi,
      epi,
      du: buildProductUrlWithColor(baseDu, color),
      iu: button.dataset.wishlistIu || '',
      dt: button.dataset.wishlistDt || '',
      pr: parseFloat(button.dataset.wishlistPr) || 0,
    };
  };

  const syncSiblings = (epi, isWishlisted) => {
    if (!epi) return;
    document
      .querySelectorAll(`[data-wishlist-toggle][data-wishlist-epi="${epi}"]`)
      .forEach((btn) => updateState(btn, isWishlisted));
  };

  const getProductPath = (url) => {
    if (!url) return '';
    try {
      return new URL(url, window.location.origin).pathname;
    } catch (_e) {
      return '';
    }
  };

  const syncNonCartSiblings = (detail, isWishlisted) => {
    const epi = Number(detail?.epi);
    if (!epi) return;
    document.querySelectorAll('[data-wishlist-toggle]').forEach((btn) => {
      if (btn.closest('.cart-product')) return;
      if (Number(btn.dataset.wishlistEpi) === epi) updateState(btn, isWishlisted);
    });
  };

  // The heart reflects the CURRENT variant only: filled means this exact epi
  // is saved. A gated heart (no resolved variant) always reads unsaved.
  const refreshFromSwym = (button) => {
    const epi = Number(button.dataset.wishlistEpi);
    if (!epi) {
      updateState(button, false);
      return;
    }
    withSwym((swat) => {
      swat.fetch((items) => {
        const saved = Array.isArray(items) ? items : [];
        const isWishlisted = saved.some((item) => Number(item.epi) === epi)
          || readPendingSavedItems().some((item) => Number(item.epi) === epi);
        const liveButtons = document.querySelectorAll(
          `[data-wishlist-toggle][data-wishlist-epi="${epi}"]`
        );
        if (liveButtons.length) {
          liveButtons.forEach((btn) => updateState(btn, isWishlisted));
        } else if (document.contains(button)) {
          updateState(button, isWishlisted);
        }
      });
    });
  };

  const showTooltipBriefly = (button) => {
    if (!button.hasAttribute('data-wishlist-tooltip')) return;
    button.classList.add('media-gallery__wishlist-toggle--show-tip');
    window.clearTimeout(button.__wishlistTipTimer);
    button.__wishlistTipTimer = window.setTimeout(() => {
      button.classList.remove('media-gallery__wishlist-toggle--show-tip');
    }, 2600);
  };

  const handleClick = (button) => {
    if (button.hasAttribute('data-wishlist-requires-selection') || button.hasAttribute('data-wishlist-unavailable')) {
      showTooltipBriefly(button);
      return;
    }
    const payload = buildPayload(button);
    if (!payload) return;
    if (button.dataset.wishlistBusy === 'true') return;
    button.dataset.wishlistBusy = 'true';

    const wasWishlisted = button.getAttribute('aria-pressed') === 'true';
    syncSiblings(payload.epi, !wasWishlisted);
    if (wasWishlisted) {
      forgetPendingSavedItem(payload);
    } else {
      rememberPendingSavedItem(payload);
    }

    withSwym((swat) => {
      const onSuccess = () => {
        button.dataset.wishlistBusy = 'false';
        if (wasWishlisted) {
          forgetPendingSavedItem(payload);
        } else {
          rememberPendingSavedItem(payload);
        }
        syncSiblings(payload.epi, !wasWishlisted);
        document.dispatchEvent(new CustomEvent('bonobos:saved-items-changed', {
          detail: {
            hasItems: !wasWishlisted,
            empi: payload.empi,
            epi: payload.epi,
            du: payload.du,
            isWishlisted: !wasWishlisted,
          },
        }));

        // Elevar dl_add_to_wishlist — fire on ADD only (not on remove).
        if (!wasWishlisted && window.BonobosElevar) {
          window.BonobosElevar.pushEvent({
            event: 'dl_add_to_wishlist',
            user_properties: window.BonobosElevar.getUserProperties(),
            event_properties: {
              currency_code: window.BonobosElevar.getCurrencyCode(),
              products: [
                window.BonobosElevar.mapProductToProduct(
                  {
                    id: String(payload.epi),
                    product_id: String(payload.empi),
                    variant_id: String(payload.epi),
                    name: payload.dt,
                    price: payload.pr, // already dollars
                    url: payload.du,
                    image: payload.iu,
                  },
                  undefined,
                  (() => { try { return location.pathname; } catch (_e) { return ''; } })(),
                ),
              ],
            },
          });
        }
      };
      const onError = () => {
        button.dataset.wishlistBusy = 'false';
        if (wasWishlisted) {
          rememberPendingSavedItem(payload);
        } else {
          forgetPendingSavedItem(payload);
        }
        syncSiblings(payload.epi, wasWishlisted);
      };
      if (wasWishlisted) {
        swat.removeFromWishList(payload, onSuccess, onError);
      } else {
        swat.addToWishList(payload, onSuccess, onError);
      }
    });
  };

  const wishlistBound = new WeakSet();

  const productAttrObserver = new MutationObserver((mutations) => {
    const seen = new Set();
    mutations.forEach((m) => {
      if (m.type !== 'attributes') return;
      if (m.attributeName !== 'data-wishlist-empi' && m.attributeName !== 'data-wishlist-epi') return;
      seen.add(m.target);
    });
    seen.forEach((button) => {
      setTimeout(() => refreshFromSwym(button), 0);
    });
  });

  const initButton = (button) => {
    if (!button) return;
    if (button.closest('.cart-product')) return;
    if (!wishlistBound.has(button)) {
      wishlistBound.add(button);
      button.addEventListener('click', () => handleClick(button));
      productAttrObserver.observe(button, {
        attributes: true,
        attributeFilter: ['data-wishlist-empi', 'data-wishlist-epi'],
      });
    }
    updateState(button, button.getAttribute('aria-pressed') === 'true');
    refreshFromSwym(button);
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll('[data-wishlist-toggle]').forEach(initButton);
  };

  // Selection gating rides variant updates: the morphed section HTML is the
  // authority for whether the heart is disabled (requires-selection when not
  // every option is picked, unavailable when the resolved variant is OOS).
  const syncGatingFromSource = (button, source) => {
    ['data-wishlist-requires-selection', 'data-wishlist-unavailable', 'aria-disabled'].forEach((attr) => {
      if (source.hasAttribute(attr)) {
        button.setAttribute(attr, source.getAttribute(attr) || '');
      } else {
        button.removeAttribute(attr);
      }
    });
    if (source.hasAttribute('data-wishlist-tooltip')) {
      button.setAttribute('data-wishlist-tooltip', source.getAttribute('data-wishlist-tooltip'));
    } else {
      button.removeAttribute('data-wishlist-tooltip');
    }
  };

  const handleVariantUpdate = (event) => {
    const variant = event?.detail?.resource;
    const data = event?.detail?.data;
    let newProductSource = null;
    if (typeof data?.html === 'string' && data.html.length) {
      try {
        const doc = new DOMParser().parseFromString(data.html, 'text/html');
        newProductSource = doc.querySelector('[data-wishlist-toggle]');
      } catch (e) {
        newProductSource = null;
      }
    }
    const fallbackDu = (() => {
      try { return location.origin + location.pathname; } catch (e) { return ''; }
    })();
    document.querySelectorAll('[data-wishlist-toggle]').forEach((button) => {
      if (newProductSource) {
        if (newProductSource.dataset.wishlistEmpi) button.dataset.wishlistEmpi = newProductSource.dataset.wishlistEmpi;
        button.dataset.wishlistEpi = newProductSource.dataset.wishlistEpi || '';
        if (newProductSource.dataset.wishlistDu) button.dataset.wishlistDu = newProductSource.dataset.wishlistDu;
        if (newProductSource.dataset.wishlistIu) button.dataset.wishlistIu = newProductSource.dataset.wishlistIu;
        if (newProductSource.dataset.wishlistDt) button.dataset.wishlistDt = newProductSource.dataset.wishlistDt;
        if (newProductSource.dataset.wishlistPr) button.dataset.wishlistPr = newProductSource.dataset.wishlistPr;
        syncGatingFromSource(button, newProductSource);
      } else {
        if (data?.productId) {
          button.dataset.wishlistEmpi = String(data.productId);
        }
        if (variant?.id) {
          button.dataset.wishlistEpi = String(variant.id);
          button.removeAttribute('data-wishlist-requires-selection');
          if (variant.available === false) {
            button.setAttribute('data-wishlist-unavailable', '');
            button.setAttribute('data-wishlist-tooltip', WISHLIST_OOS_TOOLTIP_TEXT);
            button.setAttribute('aria-disabled', 'true');
          } else {
            button.removeAttribute('data-wishlist-unavailable');
            button.removeAttribute('data-wishlist-tooltip');
            button.removeAttribute('aria-disabled');
          }
        }
        if (typeof variant?.price === 'number') {
          button.dataset.wishlistPr = (variant.price / 100).toFixed(2);
        }
        if (fallbackDu && data?.productId) {
          button.dataset.wishlistDu = fallbackDu;
        }
      }
    });
  };
  document.addEventListener('variant:update', handleVariantUpdate);

  // piv2 (PDP v2) fires variant:update only when a full selection resolves —
  // nothing fires when a selection becomes incomplete again (picking an
  // out-of-stock size clears the dependent axis). The CTA's
  // data-piv2-cta-state attribute is the selection-state authority
  // ('select' | 'add' | 'notify' | 'unavailable'), so mirror it onto the
  // heart; sticky-add-to-cart-v2.js consumes it the same way.
  const WISHLIST_TOOLTIP_TEXT = 'Select your options to save this item';
  const WISHLIST_OOS_TOOLTIP_TEXT = "Out of stock items can't be saved";

  const applyCtaStateToHearts = (cta, state) => {
    const scope = cta.closest('dialog, .shopify-section');
    let hearts = scope ? scope.querySelectorAll('[data-wishlist-toggle]') : [];
    if (!hearts.length) hearts = document.querySelectorAll('[data-wishlist-toggle]');
    hearts.forEach((button) => {
      if (button.closest('.cart-product')) return;
      if (state === 'select') {
        button.dataset.wishlistEpi = '';
        button.setAttribute('data-wishlist-requires-selection', '');
        button.setAttribute('data-wishlist-tooltip', WISHLIST_TOOLTIP_TEXT);
        button.setAttribute('aria-disabled', 'true');
        button.removeAttribute('data-wishlist-unavailable');
        updateState(button, false);
      } else if (state === 'notify' || state === 'unavailable') {
        button.removeAttribute('data-wishlist-requires-selection');
        button.setAttribute('data-wishlist-tooltip', WISHLIST_OOS_TOOLTIP_TEXT);
        button.setAttribute('data-wishlist-unavailable', '');
        button.setAttribute('aria-disabled', 'true');
      } else if (state === 'add') {
        button.removeAttribute('data-wishlist-requires-selection');
        button.removeAttribute('data-wishlist-tooltip');
        button.removeAttribute('data-wishlist-unavailable');
        button.removeAttribute('aria-disabled');
        if (!button.dataset.wishlistEpi) {
          const picker = (scope || document).querySelector('variant-picker-v2');
          const resolved = picker && typeof picker.getResolvedVariant === 'function'
            ? picker.getResolvedVariant()
            : null;
          if (resolved?.id) button.dataset.wishlistEpi = String(resolved.id);
        }
        refreshFromSwym(button);
      }
    });
  };

  const watchPiv2Cta = () => {
    document.querySelectorAll('[data-piv2-cta]').forEach((cta) => {
      if (cta.dataset.wishlistCtaWatched === 'true') return;
      cta.dataset.wishlistCtaWatched = 'true';
      new MutationObserver(() => {
        if (cta.dataset.piv2CtaState) applyCtaStateToHearts(cta, cta.dataset.piv2CtaState);
      }).observe(cta, { attributes: true, attributeFilter: ['data-piv2-cta-state'] });
      if (cta.dataset.piv2CtaState) applyCtaStateToHearts(cta, cta.dataset.piv2CtaState);
    });
  };
  watchPiv2Cta();
  new MutationObserver(() => watchPiv2Cta()).observe(document.body, { childList: true, subtree: true });

  const syncHeartsToSwym = () => {
    if (!window._swat || typeof window._swat.fetch !== 'function') return;
    window._swat.fetch((items) => {
      const saved = Array.isArray(items) ? items : [];
      document.querySelectorAll('[data-wishlist-toggle]').forEach((button) => {
        if (button.closest('.cart-product')) return;
        if (!wishlistBound.has(button)) {
          wishlistBound.add(button);
          button.addEventListener('click', () => handleClick(button));
        }
        const epi = Number(button.dataset.wishlistEpi);
        const wishlisted = Boolean(epi)
          && (saved.some((i) => Number(i.epi) === epi)
            || readPendingSavedItems().some((i) => Number(i.epi) === epi));
        if (button.getAttribute('aria-pressed') !== String(wishlisted)) {
          updateState(button, wishlisted);
        }
      });
    });
  };

  document.addEventListener('variant:update', () => {
    let attempts = 0;
    const tick = () => {
      syncHeartsToSwym();
      if (++attempts < 10) setTimeout(tick, 500);
    };
    tick();
  });

  document.addEventListener('bonobos:saved-items-changed', (event) => {
    const detail = event?.detail;
    const hasTarget = Number(detail?.empi) || Number(detail?.epi) || detail?.du;
    if (!hasTarget) {
      syncHeartsToSwym();
      setTimeout(syncHeartsToSwym, 500);
      return;
    }
    if (typeof detail?.isWishlisted === 'boolean') {
      syncNonCartSiblings(detail, detail.isWishlisted);
    }
    setTimeout(syncHeartsToSwym, 500);
  });

  window.__mediaGalleryWishlistToggle = { initAll };
  initAll();

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (!(node instanceof HTMLElement)) return;
        if (node.matches?.('[data-wishlist-toggle]')) {
          initButton(node);
          return;
        }
        node.querySelectorAll?.('[data-wishlist-toggle]').forEach(initButton);
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();

(() => {
  if (window.__pdpHeartSwymSync) return;
  window.__pdpHeartSwymSync = true;
  const updateButton = (button, isWishlisted) => {
    if (button.getAttribute('aria-pressed') === String(isWishlisted)) return;
    button.setAttribute('aria-pressed', String(isWishlisted));
    const empty = button.querySelector('[data-wishlist-empty-icon]');
    const filled = button.querySelector('[data-wishlist-filled-icon]');
    empty?.classList.toggle('hidden', isWishlisted);
    filled?.classList.toggle('hidden', !isWishlisted);
  };
  const productPath = (url) => {
    if (!url) return '';
    try {
      return new URL(url, window.location.origin).pathname;
    } catch (_e) {
      return '';
    }
  };
  const PENDING_SAVED_TTL_MS = 15 * 60 * 1000;
  const readPendingSavedItems = () => {
    try {
      const items = JSON.parse(window.localStorage.getItem('bonobos:pending-saved-items') || '[]');
      if (!Array.isArray(items)) return [];
      const cutoff = Date.now() - PENDING_SAVED_TTL_MS;
      return items.filter((item) => Number(item?.savedAt) > cutoff);
    } catch (_e) {
      return [];
    }
  };
  const hasPendingSavedItem = (button) => {
    const epi = Number(button.dataset.wishlistEpi);
    if (!epi) return false;
    return readPendingSavedItems().some((item) => Number(item?.epi) === epi);
  };
  const sync = () => {
    if (!window._swat || typeof window._swat.fetch !== 'function') return;
    window._swat.fetch((items) => {
      const saved = Array.isArray(items) ? items : [];
      document.querySelectorAll('[data-wishlist-toggle]').forEach((button) => {
        if (button.closest('.cart-product')) return;
        const epi = Number(button.dataset.wishlistEpi);
        const wishlisted = Boolean(epi)
          && (saved.some((i) => Number(i.epi) === epi) || hasPendingSavedItem(button));
        if (button.getAttribute('aria-pressed') !== String(wishlisted)) {
          button.setAttribute('aria-pressed', String(wishlisted));
          const empty = button.querySelector('[data-wishlist-empty-icon]');
          const filled = button.querySelector('[data-wishlist-filled-icon]');
          empty?.classList.toggle('hidden', wishlisted);
          filled?.classList.toggle('hidden', !wishlisted);
        }
      });
    });
  };
  const syncFromWishlistEvent = (detail) => {
    if (typeof detail?.isWishlisted !== 'boolean') return;
    const epi = Number(detail?.epi);
    if (!epi) return;
    document.querySelectorAll('[data-wishlist-toggle]').forEach((button) => {
      if (button.closest('.cart-product')) return;
      if (Number(button.dataset.wishlistEpi) === epi) updateButton(button, detail.isWishlisted);
    });
  };
  document.addEventListener('variant:update', () => {
    let attempts = 0;
    const tick = () => {
      sync();
      if (++attempts < 12) setTimeout(tick, 500);
    };
    tick();
  });
  document.addEventListener('bonobos:saved-items-changed', (event) => {
    syncFromWishlistEvent(event?.detail);
    setTimeout(sync, 500);
  });
})();
